import { Button } from '@gafe/common-ui';

import { Modal, ModalBody, ModalFooter, ModalHeader } from '@/components/proxy/reactstrap/Modal';

import { Props } from './types';

import styles from './TrainingRequiredModal.module.scss';

export const copy = {
  title: 'Action Required',
  body: 'Congratulations on your sale! Before you can submit an order, you will need to finalize enrollment steps. Please contact your GAF Energy Sales Team to discuss next action.',
  close: 'Close',
};

export const TrainingRequiredModal = (props: Props) => {
  const {
    closeTrainingRequiredModal,
    config: { isOpened, onCloseCallback },
  } = props;

  let toggle = closeTrainingRequiredModal;

  if (onCloseCallback) {
    toggle = () => {
      closeTrainingRequiredModal();
      onCloseCallback();
    };
  }

  return (
    <Modal
      centered
      className={styles.modal}
      confirmation
      fullscreen
      isOpen={isOpened}
      toggle={toggle}
    >
      <ModalHeader toggle={toggle}>{copy.title}</ModalHeader>

      <ModalBody>{copy.body}</ModalBody>

      <ModalFooter confirmation>
        <Button colorSchema="neutral" onClick={toggle} size="large" variant="text">
          {copy.close}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
